import React from 'react';
import PropTypes from 'prop-types';
import cn from '../utils/cn';
import styles from './TextLink.module.css';

const TextLink = React.forwardRef(function TextLink(
  { as, href, children, className, color, style, ...rest },
  ref
) {
  const Tag = as ?? (href ? 'a' : 'button');

  return (
    <Tag
      ref={ref}
      className={cn(styles.root, className)}
      style={color ? { color, ...style } : style}
      {...(Tag === 'button' ? { type: 'button' } : {})}
      {...(Tag === 'a' ? { href } : {})}
      {...rest}>
      {children}
    </Tag>
  );
});

TextLink.propTypes = {
  as: PropTypes.elementType,
  href: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object
};

export default TextLink;
